/* Homepage.js */

import React from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row } from 'reactstrap';

// TODO: all page

export default function Homepage() {
  return (
    <Container>
      <Row>
        <Col sm={12}>
          <Link to='/dashboard'>Dashboard</Link>
        </Col>
        <Col sm={12}>
          <Link to='/create'>Create</Link>
        </Col>
      </Row>
    </Container>
  );
}
